import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

export interface IEmailListResource {
	uuid: string;
	name: string;
}
const subscribeKey = (applicationId: Id) => ["newsletter", `${applicationId}`, "subscribe"];
const emailListsKey = (applicationId: Id) => ["newsletter", `${applicationId}`, "lists"];

export const newsletterService = {
	subscribeKey,
	emailListsKey,
	subscribe: (applicationId: Id, emailListId: Id, contactEmail: string) =>
		axios.post(keyToUrl(subscribeKey(applicationId)), { uuid: emailListId, email: contactEmail }),
	lists: (applicationId: Id, search: string, page: number, params?: Record<string, any>) =>
		axios.get<LaravelResponse<IEmailListResource[]>>(keyToUrl(emailListsKey(applicationId)), {
			params: { ...params, search, page },
		}),
};
